import { create } from "zustand"
import { persist } from "zustand/middleware"
import type { LoginResponse } from "@/providers/auth.provider"

export type AuthUser = LoginResponse

interface AuthState {
  user: AuthUser | null
  setSession: (user: AuthUser) => void
  clearSession: () => void
}

export const useAuthStore = create<AuthState>()(
  persist(
    (set) => ({
      user: null,
      setSession: (user) => set({ user }),
      clearSession: () => set({ user: null }),
    }),
    { name: "auth" }
  )
)
